import * as angular from "angular";

const statusToTitle = {
  OnDuty: 'On Duty',
  OnDutyOnBreak: 'On Break',
  OffDuty: 'Off Duty'
};

const statuses = {
  OnDuty: 'OnDuty',
  OnDutyOnBreak: 'OnDutyOnBreak',
  OffDuty: 'OffDuty'
};

const statusToBackground = {
  OnDuty: 'green-400',
  OnDutyOnBreak: 'blue-400',
  OffDuty: 'red-300'
};

angular
  .module('bringoz.admin.agents')
  .constant('agentStatus', {
    statusToTitle: statusToTitle,
    statuses: statuses,
    statusToBackground: statusToBackground
  });


